import * as React from 'react'
import Constants from 'src/helper/Constants';

const ContentTabCommonSorting = (props) => {
    const { homePageAllTabs } = Constants;

    return (
        <>
            <div className='all-content-header'>
                <div className="bs5 row mt-1">
                    <div className="col-auto">
                        <div className='font-oswald font-light font-30 text-uppercase'>{props.headerNme}</div>
                    </div>
                    {props.dataLength ?
                        <div className="col-auto ms-auto align-self-end">
                            <div className='d-flex align-items-center'>
                                <label className='mb-0 me-3'>Sort By:</label>
                                <div className="selectbox">
                                    <select className="form-control form-control-xs w210" onChange={props.onFilter}>
                                        <option value='Relevance'>Relevance </option>
                                        {props.headerNme == homePageAllTabs.ARTICLE.tabHeader && <option value='MostRecent'>Most Recent</option>}
                                        <option value='NameASC'>Name - A to Z</option>
                                        <option value='NameDESC'>Name - Z to A</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        : ''
                    }
                </div>
            </div>
        </>
    )
}

export default ContentTabCommonSorting